import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { getAvailabeCasesAction } from '../Actions/cases';
import MedicalReportTable from '../components/datatables/medicalReportTable';

const Reports = () => {

  const [cases, setSetCases] = useState([]);
  const { activeSite } = useSelector((state) => state);

  useEffect(()=> {
    fetchCases();
  }, []);

  const fetchCases = async ()=> {
    var result = await getAvailabeCasesAction(activeSite || localStorage.getItem('portal-active-site-id'));
    setSetCases(result? result?.data : []);
  }
  
  
  //console.log('siteDocuments',site)
  return (
    <div >
      
      <div className="flex items-center mb-[29px]">
        {cases && (
          <MedicalReportTable data={cases} />
        )}
      </div>
    </div>
  )
}


export default Reports;